import realtorAuth from "./realtor-auth.js";

// NZSC-3212: 공인중개사 도메인 store. 현재는 자체 아이디/비밀번호 인증(authStore)만 보유.
export const state = {};

export const mutations = {};

export const actions = {};

export const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
  modules: {
    authStore: realtorAuth,
  },
};
